import icon from "@material-ui/icons/Receipt";
import InvoiceList from "./list";

export default {
  icon,
  list: InvoiceList
};